module.exports = __webpack_public_path__ + "static/media/device_driver.55eee25f.png";